export default class HelpView {
    constructor(parent, router) {
        this.router = router;
        this.el = parent.el.querySelector('.help-view');
        this.backLink = this.el.querySelector('#back-to-form');
        
        this.bind();
    }

    show() {
        this.el.classList.remove('hide');
    }

    hide() {
        this.el.classList.add('hide');
    }

    bind() {
        this.backLink.addEventListener('click', (e) => {
            e.preventDefault();
            this.router.update('form');
        });
    }
}
